<template>
  <div class="review-card" @click="handleClick">
    <div class="review-card__thumbnail">
      <img
        v-if="review.thumbnail && !imageError"
        :src="review.thumbnail"
        :alt="review.title"
        @error="handleImageError"
      >
      <div v-else class="review-card__no-image"></div>
    </div>
    <div class="review-card__content">
      <p class="review-card__store">{{ review.storeName }}</p>
      <h3 class="review-card__title">{{ review.title }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewCard',
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      imageError: false
    };
  },
  methods: {
    handleClick() {
      this.$emit('click', this.review.id);
    },
    handleImageError() {
      this.imageError = true;
    }
  }
};
</script>

<style scoped lang="scss">
.review-card {
  cursor: pointer;
  margin-bottom: 30px;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }
}

.review-card__thumbnail {
  width: 100%;
  padding-top: 75%; // 4:3 비율
  position: relative;
  overflow: hidden;
  margin-bottom: 15px;
  border: 1px solid #E5E5E5;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.review-card__no-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  background-image: url("../assets/images/banners/04/symbol-up-down.png");
  background-repeat: no-repeat;
  background-size: 30%;
  background-position: center center;

}

.review-card__content {
  text-align: center;
}

.review-card__store {
  font-size: 16px;
  color: #999;
  margin-bottom: 8px;
  line-height: 1.4;
}

.review-card__title {
  font-size: 20px;
  font-weight: 700;
  color: #222;
  line-height: 1.5;
  word-break: keep-all;
}

// =========================================================================
// 모바일 반응형 (768px 이하)
// =========================================================================
@media (max-width: 768px) {
  .review-card {
    margin-bottom: 0;
  }

  .review-card__thumbnail {
    margin-bottom: 12px;
  }

  .review-card__store {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .review-card__title {
    font-size: 16px;
    line-height: 1.4;
  }
}
</style>
